export default "__VITE_ASSET__b30c19d3__"